<template>
  <div v-if="error">
    <v-icon color="red">
      eva-close-circle
    </v-icon>
    {{ errorMessage }}
  </div>
  <div v-else-if="loading">
    <SmallSpinner class="mr-1 my-1" />
    {{ loadingMessage }}
  </div>
  <div v-else-if="saving">
    <SmallSpinner class="mr-1 my-1" />
    {{ savingMessage }}
  </div>
  <SuccessSaveMessage v-else-if="lastSaveSuccessful" :savedAt="savedAt" />
  <div v-else>
    <v-icon>eva-alert-circle-outline</v-icon>
    {{ notSavedMessage }}
  </div>
</template>

<script>
import SmallSpinner from "@/components/ui/load_status/small_spinner.vue";
import SuccessSaveMessage from "@/components/ui/form/save_status/success_save_message.vue";

export default {
  name: "SaveStatus",
  components: { SmallSpinner, SuccessSaveMessage },
  props: {
    savedAt: {
      type: String,
      required: false,
      default: null,
    },
    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
    pending: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    savingMessage: {
      type: String,
      required: false,
      default: "Salvando...",
    },
    notSavedMessage: {
      type: String,
      required: false,
      default: "Registro ainda não salvo.",
    },
    errorMessage: {
      type: String,
      required: false,
      default: "Erro ao salvar.",
    },
    loadingMessage: {
      type: String,
      required: false,
      default: "Carregando...",
    },
  },
  computed: {
    lastSaveSuccessful() {
      if (!this.savedAt) return false;

      return !this.pending;
    },
  },
};
</script>

<style scoped></style>
